/* ==========================================================================
   Mocha & Mood - cushion configurator
   Shape / Style / Colour -> variant match -> preview + silent add to cart.

   Expects markup from sections/mm-configurator.liquid:
     [data-mm-config]                    root, holds JSON script tags
     script[data-mm-variants]            product variants as JSON
     script[data-mm-fallbacks]           { "Square": "url", ... } per-shape images
     [data-mm-opt][data-mm-axis][data-mm-value]   option buttons
     [data-mm-preview]                   <img>
     [data-mm-caption-dot]               caption swatch
     [data-mm-caption-text]              caption text
     [data-mm-price]                     optional price node
     [data-mm-submit]                    add to bag button
     select[name="id"]                   no-JS fallback, kept in sync
   ========================================================================== */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  var AXES = ['shape', 'style', 'colour'];

  function money(cents, format) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '{{amount}}').replace(/\{\{\s*amount\s*\}\}/, v);
  }

  function Configurator(root) {
    this.root = root;
    this.sticky = root.hasAttribute('data-mm-sticky');
    this.moneyFormat = root.getAttribute('data-mm-money') || '{{amount}}';
    this.soldOutLabel = root.getAttribute('data-mm-soldout') || 'SOLD OUT';
    this.addLabel = root.getAttribute('data-mm-addlabel') || 'ADD TO BAG';

    this.variants = this.json('[data-mm-variants]') || [];
    this.fallbacks = this.json('[data-mm-fallbacks]') || {};
    this.placeholder = root.getAttribute('data-mm-placeholder') || '';

    this.preview = root.querySelector('[data-mm-preview]');
    this.dot = root.querySelector('[data-mm-caption-dot]');
    this.captionText = root.querySelector('[data-mm-caption-text]');
    this.dimsNode = root.querySelector('[data-mm-dims]');
    this.priceNode = root.querySelector('[data-mm-price]');
    this.submit = root.querySelector('[data-mm-submit]');
    this.select = root.querySelector('select[name="id"]');
    this.form = root.querySelector('form[action*="/cart/add"]');

    this.selection = {};
    var self = this;
    AXES.forEach(function (axis) {
      var pressed = root.querySelector('[data-mm-axis="' + axis + '"][aria-pressed="true"]');
      var first = root.querySelector('[data-mm-axis="' + axis + '"]');
      var el = pressed || first;
      self.selection[axis] = el ? el.getAttribute('data-mm-value') : '';
    });

    this.bind();
    this.update({ pushUrl: false });
  }

  Configurator.prototype.json = function (sel) {
    var node = this.root.querySelector(sel);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  };

  Configurator.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mm-opt]');
      if (btn && self.root.contains(btn)) {
        e.preventDefault();
        if (btn.getAttribute('aria-disabled') === 'true') return;
        self.selection[btn.getAttribute('data-mm-axis')] = btn.getAttribute('data-mm-value');
        self.update({ pushUrl: true });
      }
    });

    // Arrow-key navigation within a group
    this.root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var btn = e.target.closest('[data-mm-opt]');
      if (!btn) return;
      var group = Array.prototype.slice.call(
        self.root.querySelectorAll('[data-mm-axis="' + btn.getAttribute('data-mm-axis') + '"]')
      );
      var i = group.indexOf(btn);
      var next = group[e.key === 'ArrowRight' ? i + 1 : i - 1];
      if (next) { e.preventDefault(); next.focus(); next.click(); }
    });

    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        if (!window.fetch) return;               // let it post normally
        e.preventDefault();
        self.addToCart();
      });
    }
  };

  Configurator.prototype.match = function () {
    var s = this.selection;
    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i];
      if (v.option1 === s.shape && v.option2 === s.style && v.option3 === s.colour) return v;
    }
    return null;
  };

  // Does at least one variant exist for this axis/value, given the CURRENT
  // selection on the other two axes? Used to grey out impossible combos
  // (e.g. Striped isn't offered in Stone or Espresso).
  Configurator.prototype.hasMatch = function (axis, value) {
    var s = this.selection;
    var test = { shape: s.shape, style: s.style, colour: s.colour };
    test[axis] = value;
    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i];
      if (v.option1 === test.shape && v.option2 === test.style && v.option3 === test.colour) return true;
    }
    return false;
  };

  Configurator.prototype.updateAvailability = function () {
    var self = this;
    AXES.forEach(function (axis) {
      var btns = self.root.querySelectorAll('[data-mm-axis="' + axis + '"]');
      Array.prototype.forEach.call(btns, function (b) {
        var value = b.getAttribute('data-mm-value');
        var ok = self.hasMatch(axis, value);
        b.classList.toggle('mm-opt--unavailable', !ok);
        b.setAttribute('aria-disabled', ok ? 'false' : 'true');
      });
    });

    // If the current selection has drifted onto a combination that doesn't
    // exist (e.g. Colour just changed away from one that offered Striped),
    // fall back to the first available value on that same axis rather than
    // leaving the picker stuck on a dead combination.
    var s = this.selection;
    if (!this.match()) {
      var styleBtns = this.root.querySelectorAll('[data-mm-axis="style"]');
      for (var i = 0; i < styleBtns.length; i++) {
        var candidate = styleBtns[i].getAttribute('data-mm-value');
        if (this.hasMatch('style', candidate)) { s.style = candidate; break; }
      }
    }
  };

  Configurator.prototype.update = function (opts) {
    var self = this;
    this.updateAvailability();
    var variant = this.match();

    AXES.forEach(function (axis) {
      var btns = self.root.querySelectorAll('[data-mm-axis="' + axis + '"]');
      Array.prototype.forEach.call(btns, function (b) {
        var on = b.getAttribute('data-mm-value') === self.selection[axis];
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });

    // Preview: variant image -> shape fallback -> section placeholder
    if (this.preview) {
      var src = (variant && variant.featured_image && variant.featured_image.src) ||
                this.fallbacks[this.selection.shape] ||
                this.placeholder;
      if (src && this.preview.getAttribute('src') !== src) {
        this.preview.setAttribute('src', src);
        this.preview.setAttribute('alt',
          [this.selection.shape, this.selection.style, this.selection.colour].join(' ') + ' cushion');
      }
    }

    // Caption
    if (this.captionText) {
      this.captionText.textContent =
        [this.selection.shape, this.selection.style, this.selection.colour].join(' / ').toUpperCase();
    }
    if (this.dimsNode) {
      var dimsMap = { 'Square': '45 × 45 CM', 'Lumbar': '50 × 30 CM', 'Bolster': '60 × 20 CM' };
      this.dimsNode.textContent = dimsMap[this.selection.shape] || '';
    }
    if (this.dot) {
      var swatch = this.root.querySelector(
        '[data-mm-axis="colour"][data-mm-value="' + this.selection.colour + '"] [data-mm-swatch]'
      );
      if (swatch) this.dot.style.background = getComputedStyle(swatch).backgroundColor;
    }

    if (this.priceNode && variant) this.priceNode.textContent = money(variant.price, this.moneyFormat);

    // Availability
    var available = !!(variant && variant.available);
    if (this.submit) {
      this.submit.disabled = !available;
      this.submit.setAttribute('aria-disabled', available ? 'false' : 'true');
      this.submit.textContent = available ? this.addLabel : this.soldOutLabel;
    }

    if (this.select && variant) this.select.value = variant.id;

    if (opts && opts.pushUrl && variant && window.history && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }

    this.root.dispatchEvent(new CustomEvent('mm:variant:change', { detail: { variant: variant }, bubbles: true }));
  };

  Configurator.prototype.addToCart = function () {
    var self = this;
    var variant = this.match();
    if (!variant || !variant.available) return;

    if (this.submit) this.submit.setAttribute('aria-busy', 'true');

    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return self.refreshCartCount(); })
      .then(function () { toast(self.root.getAttribute('data-mm-toast') || 'Added to bag'); })
      .catch(function () { toast('Something went wrong'); })
      .then(function () { if (self.submit) self.submit.removeAttribute('aria-busy'); });
  };

  // Update Dawn's cart bubble without a page reload
  Configurator.prototype.refreshCartCount = function () {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nodes = document.querySelectorAll('.cart-count-bubble span:first-child, [data-mm-cart-count]');
        Array.prototype.forEach.call(nodes, function (n) { n.textContent = cart.item_count; });
        var bubble = document.querySelector('.cart-count-bubble');
        if (bubble) bubble.hidden = cart.item_count === 0;
        document.dispatchEvent(new CustomEvent('mm:cart:updated', { detail: { cart: cart } }));
      });
  };

  var toastEl, toastTimer;
  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'mm-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2500);
  }

  /* ------------------------------------------------------------------------
     Header Shop dropdown - click to open, not hover
     ------------------------------------------------------------------------ */
  /* ------------------------------------------------------------------------
     Sub-dropdown (Collections / Bundles inside the Shop panel) - same
     click/outside/Escape pattern as the main dropdown, but also closes any
     other open sibling sub-panel so only the last one opened stays visible.
     ------------------------------------------------------------------------ */
  function initSubDropdown(wrap) {
    var trigger = wrap.querySelector('[data-mm-subdropdown-trigger]');
    var panel = wrap.querySelector('[data-mm-subdropdown-panel]');
    if (!trigger || !panel) return;

    function closeSiblings() {
      var parentPanel = wrap.closest('[data-mm-dropdown-panel]');
      if (!parentPanel) return;
      Array.prototype.forEach.call(parentPanel.querySelectorAll('[data-mm-subdropdown]'), function (sib) {
        if (sib !== wrap) {
          var sibTrigger = sib.querySelector('[data-mm-subdropdown-trigger]');
          var sibPanel = sib.querySelector('[data-mm-subdropdown-panel]');
          if (sibTrigger) sibTrigger.setAttribute('aria-expanded', 'false');
          if (sibPanel) sibPanel.hidden = true;
          sib.classList.remove('is-open');
        }
      });
    }

    function set(open) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
      wrap.classList.toggle('is-open', open);
      if (open) closeSiblings();
    }
    set(false);

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      set(trigger.getAttribute('aria-expanded') !== 'true');
    });
  }

  function initDropdown(wrap) {
    var trigger = wrap.querySelector('[data-mm-dropdown-trigger]');
    var panel = wrap.querySelector('[data-mm-dropdown-panel]');
    if (!trigger || !panel) return;

    function set(open) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
      wrap.classList.toggle('is-open', open);
      if (!open) {
        Array.prototype.forEach.call(panel.querySelectorAll('[data-mm-subdropdown]'), function (sub) {
          var subTrigger = sub.querySelector('[data-mm-subdropdown-trigger]');
          var subPanel = sub.querySelector('[data-mm-subdropdown-panel]');
          if (subTrigger) subTrigger.setAttribute('aria-expanded', 'false');
          if (subPanel) subPanel.hidden = true;
          sub.classList.remove('is-open');
        });
      }
    }
    set(false);

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      set(trigger.getAttribute('aria-expanded') !== 'true');
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) set(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') { set(false); trigger.focus(); }
    });
    wrap.addEventListener('focusout', function (e) {
      if (!wrap.contains(e.relatedTarget)) set(false);
    });
  }

  /* ------------------------------------------------------------------------
     Mobile nav drawer  -  same click/outside/Escape pattern as the dropdown,
     plus the Shop accordion inside it reuses initDropdown().
     ------------------------------------------------------------------------ */
  function initMobileNav(trigger) {
    var panelId = trigger.getAttribute('aria-controls');
    var panel = document.getElementById(panelId);
    if (!panel) return;
    var closeBtn = panel.querySelector('[data-mm-mobilenav-close]');

    function set(open) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }
    trigger.addEventListener('click', function () { set(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { set(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) { set(false); trigger.focus(); }
    });
  }

  /* ------------------------------------------------------------------------
     Filter bar  -  FILTER button + checkbox dropdown on the two listing
     templates. Checkboxes filter a card grid client-side; see
     05-PAGES.md for the exact data-attributes each card needs.
     ------------------------------------------------------------------------ */
  function initFilterBar(bar) {
    var btn = bar.querySelector('[data-mm-filter-trigger]');
    var panel = bar.querySelector('[data-mm-filter-panel]');
    if (!btn || !panel) return;
    var grid = document.querySelector(bar.getAttribute('data-mm-filter-target'));

    function setOpen(open) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.classList.toggle('is-open', open);
      panel.hidden = !open;
    }
    setOpen(false);
    btn.addEventListener('click', function (e) { e.preventDefault(); setOpen(btn.getAttribute('aria-expanded') !== 'true'); });
    document.addEventListener('click', function (e) { if (!bar.contains(e.target)) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });

    function applyFilters() {
      var active = {};
      Array.prototype.forEach.call(panel.querySelectorAll('input[type="checkbox"]'), function (cb) {
        var axis = cb.getAttribute('data-mm-filter-axis');
        active[axis] = active[axis] || [];
        if (cb.checked) active[axis].push(cb.value);
      });
      var count = 0;
      Object.keys(active).forEach(function (axis) {
        var group = panel.querySelectorAll('input[data-mm-filter-axis="' + axis + '"]');
        if (active[axis].length < group.length) count += group.length - active[axis].length;
      });
      var badge = btn.querySelector('[data-mm-filter-count]');
      if (badge) { badge.hidden = count === 0; badge.textContent = count; }
      if (!grid) return;
      Array.prototype.forEach.call(grid.querySelectorAll('[data-mm-card]'), function (card) {
        var visible = Object.keys(active).every(function (axis) {
          var val = card.getAttribute('data-mm-card-' + axis);
          return !val || active[axis].indexOf(val) > -1;
        });
        card.hidden = !visible;
      });
    }
    panel.addEventListener('change', applyFilters);
    var clear = panel.querySelector('[data-mm-filter-clear]');
    if (clear) clear.addEventListener('click', function (e) {
      e.preventDefault();
      Array.prototype.forEach.call(panel.querySelectorAll('input[type="checkbox"]'), function (cb) { cb.checked = true; });
      applyFilters();
    });
    applyFilters();
  }

  function initAccordion(root) {
    var items = root.querySelectorAll('[data-mm-accordion-trigger]');
    Array.prototype.forEach.call(items, function (trigger) {
      trigger.addEventListener('click', function () {
        var panel = trigger.parentElement.querySelector('[data-mm-accordion-panel]');
        var open = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) { panel.hidden = open; }
      });
    });
  }

  function init(scope) {
    var r = scope || document;
    Array.prototype.forEach.call(r.querySelectorAll('[data-mm-config]'), function (el) {
      if (!el.__mm) { el.__mm = new Configurator(el); }
    });
    Array.prototype.forEach.call(r.querySelectorAll('[data-mm-dropdown]'), function (el) {
      if (!el.__mmDd) { el.__mmDd = true; initDropdown(el); }
    });
    Array.prototype.forEach.call(r.querySelectorAll('[data-mm-subdropdown]'), function (el) {
      if (!el.__mmSubDd) { el.__mmSubDd = true; initSubDropdown(el); }
    });
    Array.prototype.forEach.call(r.querySelectorAll('[data-mm-mobilenav-trigger]'), function (el) {
      if (!el.__mmNav) { el.__mmNav = true; initMobileNav(el); }
    });
    Array.prototype.forEach.call(r.querySelectorAll('[data-mm-filterbar]'), function (el) {
      if (!el.__mmFilter) { el.__mmFilter = true; initFilterBar(el); }
    });
    Array.prototype.forEach.call(r.querySelectorAll('.mm-accordion'), function (el) {
      if (!el.__mmAcc) { el.__mmAcc = true; initAccordion(el); }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  // Theme editor re-renders sections without a reload
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.MochaMood = { init: init, toast: toast };
})();